export var version = "3.12.7";
//# sourceMappingURL=version.js.map